import { Routes, Route } from "react-router-dom";
import { SITE_ORIGIN } from "../../siteConfig";

import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import HomePage from "../../pages/home";
import AboutPage from "../../separatePages/aboutPage";
import TeamPage from "../../separatePages/teamPage";
import KhargharBranch from "../../separatePages/khargharBranch";

import MaleHairLoss from "../../hairloss/maleHairLoss";
import FemaleHairLoss from "../../hairloss/femalehairloss";

import HairTransplantIndia from "../../hitindia/hairTransplantIndia";
import HairTransplantCostIndia from "../../hitindia/hairtransplantcost";
import HairTransplantInMumbai from "../../hitindia/hairtransplantinmumbai";
import HairTransplantSurgery from "../../hitindia/hairtransplantsurgery";

import AboutHairTransplant from "../../treatments/aboutHT";
import MaleHairTransplant from "../../treatments/malehairtransplant";
import FemaleHairTransplant from "../../treatments/femalehairtransplant";
import BeardHairTransplant from "../../treatments/beardhairtransplant";
import EyebrowHairTransplant from "../../treatments/eyebrowhairtransplant";
import BodyHairTransplant from "../../treatments/bodyhairtransplant";
import HairlineReconstruction from "../../treatments/hairlinereconstruction";
import EyelashHairTransplant from "../../treatments/eyelashhairtransplant";
import PRP from "../../treatments/prp";
import LowLevelLaserTherapy from "../../treatments/lowlevellasertherapy";
import CyclicVitaminTherapy from "../../treatments/cyclicvitamintherapy";
import TropicalHairLossTreatment from "../../treatments/topicaloraltherapy";
import FUEHairTransplant from "../../treatments/fuehairtransplant";
import FUTHairTransplant from "../../treatments/futhairtransplant";

import TrainingPage from "../../separatePages/trainingpage";
import ClientTestimonials from "../../separatePages/clienttestimonials";
import FaqPage from "../../separatePages/faq";
import Results from "../../separatePages/results";

function NaviMumbaiLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

const u = (path) => `${SITE_ORIGIN}${path}`;

export default function SiteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<NaviMumbaiLayout><HomePage /></NaviMumbaiLayout>} />
      <Route path="/description.php" element={<NaviMumbaiLayout><AboutPage /></NaviMumbaiLayout>} />
      <Route path="/our-Surgeons.php" element={<NaviMumbaiLayout><TeamPage /></NaviMumbaiLayout>} />
      <Route path="/khargharNaviMumbai.php" element={<NaviMumbaiLayout><KhargharBranch /></NaviMumbaiLayout>} />

      <Route path="/male-hair-loss.php" element={<NaviMumbaiLayout><MaleHairLoss /></NaviMumbaiLayout>} />
      <Route path="/female-hair-loss.php" element={<NaviMumbaiLayout><FemaleHairLoss /></NaviMumbaiLayout>} />
      <Route path="/hair-transplant-in-india.php" element={<NaviMumbaiLayout><HairTransplantIndia /></NaviMumbaiLayout>} />
      <Route path="/hair-transplant-cost-in-india.php" element={<NaviMumbaiLayout><HairTransplantCostIndia /></NaviMumbaiLayout>} />
      <Route path="/hair-transplant-in-mumbai.php" element={<NaviMumbaiLayout><HairTransplantInMumbai /></NaviMumbaiLayout>} />
      <Route path="/hair-transplant-surgery-in-india.php" element={<NaviMumbaiLayout><HairTransplantSurgery /></NaviMumbaiLayout>} />

      <Route path="/results" element={<NaviMumbaiLayout><Results /></NaviMumbaiLayout>} />
      <Route path="/trainings.php" element={<NaviMumbaiLayout><TrainingPage url={u("/trainings.php")} /></NaviMumbaiLayout>} />
      <Route path="/client-testimonials.php" element={<NaviMumbaiLayout><ClientTestimonials url={u("/client-testimonials.php")} /></NaviMumbaiLayout>} />
      <Route path="/faq.php" element={<NaviMumbaiLayout><FaqPage url={u("/faq.php")} /></NaviMumbaiLayout>} />

      <Route path="/about-hair-transplants.php" element={<NaviMumbaiLayout><AboutHairTransplant url={u("/about-hair-transplants.php")} /></NaviMumbaiLayout>} />
      <Route path="/male-hair-transplants.php" element={<NaviMumbaiLayout><MaleHairTransplant url={u("/male-hair-transplants.php")} /></NaviMumbaiLayout>} />
      <Route path="/female-hair-transplants.php" element={<NaviMumbaiLayout><FemaleHairTransplant url={u("/female-hair-transplants.php")} /></NaviMumbaiLayout>} />
      <Route path="/beard-hair-transplants.php" element={<NaviMumbaiLayout><BeardHairTransplant url={u("/beard-hair-transplants.php")} /></NaviMumbaiLayout>} />
      <Route path="/eyebrow-hair-transplants.php" element={<NaviMumbaiLayout><EyebrowHairTransplant url={u("/eyebrow-hair-transplants.php")} /></NaviMumbaiLayout>} />
      <Route path="/body-hairs-transplants.php" element={<NaviMumbaiLayout><BodyHairTransplant url={u("/body-hairs-transplants.php")} /></NaviMumbaiLayout>} />
      <Route path="/hairline-reconstruction.php" element={<NaviMumbaiLayout><HairlineReconstruction url={u("/hairline-reconstruction.php")} /></NaviMumbaiLayout>} />
      <Route path="/eyelash-hair-transplants.php" element={<NaviMumbaiLayout><EyelashHairTransplant url={u("/eyelash-hair-transplants.php")} /></NaviMumbaiLayout>} />
      <Route path="/platelet-rich-plasma.php" element={<NaviMumbaiLayout><PRP /></NaviMumbaiLayout>} />
      <Route path="/laser-light-therapy.php" element={<NaviMumbaiLayout><LowLevelLaserTherapy /></NaviMumbaiLayout>} />
      <Route path="/cyclic-vitamin-therapy.php" element={<NaviMumbaiLayout><CyclicVitaminTherapy /></NaviMumbaiLayout>} />
      <Route path="/topical-therapy.php" element={<NaviMumbaiLayout><TropicalHairLossTreatment /></NaviMumbaiLayout>} />
      <Route path="/follicular-unit-extraction.php" element={<NaviMumbaiLayout><FUEHairTransplant /></NaviMumbaiLayout>} />
      <Route path="/follicular-unit-transplant.php" element={<NaviMumbaiLayout><FUTHairTransplant /></NaviMumbaiLayout>} />
    </Routes>
  );
}